import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-570b27eb"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container mb-10" }
const _hoisted_2 = { class: "row mt-n15 px-md-20 g-5" }
const _hoisted_3 = { class: "card bg-white mt-2" }
const _hoisted_4 = { class: "table-responsive row justify-content-center p-4 my-5" }
const _hoisted_5 = { class: "table table-bordered text-start data-table" }
const _hoisted_6 = {
  class: "fw-bolder fs-6 text-uppercase gs-0",
  role: "row"
}
const _hoisted_7 = {
  key: 0,
  class: "px-2"
}
const _hoisted_8 = { key: 1 }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("tbody", { class: "px-2" }, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      rowspan: "4",
      style: {"border-left":"1px solid #eee"},
      class: "px-2"
    }, " 1. "),
    /*#__PURE__*/_createElementVNode("td", { rowspan: "4" }, "Pengurusan Perkhidmatan (Akauntan)"),
    /*#__PURE__*/_createElementVNode("td", null, "Fara Waheedah binti Ahmad"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1100"),
    /*#__PURE__*/_createElementVNode("td", null, "waheedah")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Musfirah binti Ibharim @ Ibrahim"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1142"),
    /*#__PURE__*/_createElementVNode("td", null, "musfirah")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Nurulhuda binti Hamzah"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1081"),
    /*#__PURE__*/_createElementVNode("td", null, "huda.hamzah")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Norshariza binti Esa"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1098"),
    /*#__PURE__*/_createElementVNode("td", null, "shariza.esa")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      rowspan: "4",
      style: {"border-left":"1px solid #eee"},
      class: "px-2"
    }, " 2. "),
    /*#__PURE__*/_createElementVNode("td", { rowspan: "4" }, "Pengurusan Perkhidmatan (Penolong Akauntan)"),
    /*#__PURE__*/_createElementVNode("td", null, "Nuqayyah binti Che Kamaludin"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1037"),
    /*#__PURE__*/_createElementVNode("td", null, "nuqayyah")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Siti Nuraishah binti Hasnan"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1361"),
    /*#__PURE__*/_createElementVNode("td", null, "aishah.hasnan")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Nurul Ashikin binti Jusoh"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1060"),
    /*#__PURE__*/_createElementVNode("td", null, "nurulashikin")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Norhazliza binti Mohd Nasir"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1092"),
    /*#__PURE__*/_createElementVNode("td", null, "norhazliza")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      rowspan: "3",
      style: {"border-left":"1px solid #eee"},
      class: "px-2"
    }, " 3. "),
    /*#__PURE__*/_createElementVNode("td", { rowspan: "3" }, "Pengurusan Perkhidmatan (Pembantu Akauntan)"),
    /*#__PURE__*/_createElementVNode("td", null, "Nuqayyah binti Che Kamaludin"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1037"),
    /*#__PURE__*/_createElementVNode("td", null, "nuqayyah")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Siti Nuraishah binti Hasnan"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1361"),
    /*#__PURE__*/_createElementVNode("td", null, "aishah.hasnan")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Mohd Azrol Nizam bin Mohd Suhaimi"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1093"),
    /*#__PURE__*/_createElementVNode("td", null, "azrolnizam")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      rowspan: "2",
      style: {"border-left":"1px solid #eee"},
      class: "px-2"
    }, " 4. "),
    /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, " Pengurusan Perkhidmatan (TBK 1 & TBK 2(Gunasama)) "),
    /*#__PURE__*/_createElementVNode("td", null, "Ummul Syafiqah binti Ruslan"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1094"),
    /*#__PURE__*/_createElementVNode("td", null, "syafiqah.ruslan")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Doa Omar Mohammad Samae"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1110"),
    /*#__PURE__*/_createElementVNode("td", null, "doa")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      rowspan: "4",
      class: "px-2",
      style: {"border-left":"1px solid #eee"}
    }, " 5. "),
    /*#__PURE__*/_createElementVNode("td", { rowspan: "4" }, "Pengurusan Peperiksaan"),
    /*#__PURE__*/_createElementVNode("td", null, "Izzul Fadzli bin Zulkefli"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1240"),
    /*#__PURE__*/_createElementVNode("td", null, "izzul")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Nor Azimah binti Ab Manaf"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1183"),
    /*#__PURE__*/_createElementVNode("td", null, "n.azimah")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Nur Solehah binti Saidi"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1197"),
    /*#__PURE__*/_createElementVNode("td", null, "solehah.saidi")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", { style: {"padding-left":"5px"} }, "Norshamira Natasha binti Ibrahim"),
    /*#__PURE__*/_createElementVNode("td", null, "03-8882 1197"),
    /*#__PURE__*/_createElementVNode("td", null, "shamira.ibrahim")
  ]),
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("td", {
      rowspan: "2",
      class: "px-2",
      style: {"border-left":"1px solid #eee"}
    }, " 6. "),
    /*#__PURE__*/_createElementVNode("td", { rowspan: "2" }, "Teknikal Sistem"),
    /*#__PURE__*/_createElementVNode("td", null, "Meja Bantuan Sistem (Panggilan / Whatsapp)"),
    /*#__PURE__*/_createElementVNode("td", null, "012-521 9051"),
    /*#__PURE__*/_createElementVNode("td", null, "teknikal_ispk")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Masthead = _resolveComponent("Masthead")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Masthead, {
      minHeight: 35,
      text: "Hubungi Kami",
      backgroundUrl: "media/svg/misc/background.svg",
      fontSize: 2
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("table", _hoisted_5, [
              _createElementVNode("thead", null, [
                _createElementVNode("tr", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.headerConfig, (cell, i) => {
                    return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
                      (i == 0)
                        ? (_openBlock(), _createElementBlock("th", _hoisted_7, _toDisplayString(cell.name), 1))
                        : (_openBlock(), _createElementBlock("th", _hoisted_8, _toDisplayString(cell.name), 1))
                    ], 64))
                  }), 128))
                ])
              ]),
              _hoisted_9
            ])
          ])
        ])
      ])
    ])
  ], 64))
}